import {Injectable} from '@angular/core';
import {OnBoardingApi} from '../../../shared/nestjs/gd-only/services/on-boarding.api';
import {Storage} from '@ionic/storage';
import {ResponseOnBoardingDto} from '../../../shared/nestjs/gd-only/dto/on-boarding.dto';

@Injectable()
export class OnBoardingBloc {
  constructor(
      private onBoardingApi: OnBoardingApi,
      private storage: Storage,
  ) {
  }

  async getOnBoardingData(): Promise<ResponseOnBoardingDto> {
    try {
      const auth = JSON.parse(await this.storage.get('SFGoAuth'));
      const result = await this.onBoardingApi.getOnBoardingData({empId: auth.empId}).toPromise();
      return Promise.resolve(result.data)
    } catch (e) {
      console.log('catch err : ', e);
      return Promise.resolve(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/bloc/feature/on-boarding/on-boarding.bloc.ts